import { render, staticRenderFns } from "./PcGameListSection.vue?vue&type=template&id=d12b907a&scoped=true"
import script from "./PcGameListSection.vue?vue&type=script&lang=ts"
export * from "./PcGameListSection.vue?vue&type=script&lang=ts"
import style0 from "./PcGameListSection.vue?vue&type=style&index=0&id=d12b907a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12b907a",
  null
  
)

export default component.exports